import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { UserInfo } from "../../../components/header/header.component";
import { IRegion } from "../../../shared/models/models";
import { EventService } from "../../../shared/services/event.service";
import { ServerService } from "../../../shared/services/server.service";

@Component({
  selector: "app-map",
  templateUrl: "./map.component.html",
  styleUrls: ["./map.component.scss"],
})
export class MapComponent implements OnInit {
  @Input() mapModal;
  regions: IRegion[] = [];
  total: number = 0;
  loading: boolean = false;
  portalId = 1;
  user: UserInfo = null;
  matchingRegions = [
    {
      id: 100000000,
      name: "область Абай",
      oldId: 18,
    },
    {
      id: 110000000,
      name: "Акмолинская область",
      oldId: 3,
    },
    {
      id: 150000000,
      name: "Актюбинская область",
      oldId: 4,
    },
    {
      id: 190000000,
      name: "Алматинская область",
      oldId: 5,
    },
    {
      id: 230000000,
      name: "Атырауская область",
      oldId: 6,
    },
    {
      id: 270000000,
      name: "Западно-Казахстанская область",
      oldId: 7,
    },
    {
      id: 310000000,
      name: "Жамбылская область",
      oldId: 8,
    },
    {
      id: 330000000,
      name: "область Жетісу",
      oldId: 19,
    },
    {
      id: 350000000,
      name: "Карагандинская область",
      oldId: 9,
    },
    {
      id: 390000000,
      name: "Костанайская область",
      oldId: 10,
    },
    {
      id: 430000000,
      name: "Кызылординская область",
      oldId: 11,
    },
    {
      id: 470000000,
      name: "Мангистауская область",
      oldId: 12,
    },
    {
      id: 550000000,
      name: "Павлодарская область",
      oldId: 14,
    },
    {
      id: 590000000,
      name: "Северо-Казахстанская область",
      oldId: 15,
    },
    {
      id: 610000000,
      name: "Туркестанская область",
      oldId: 17,
    },
    {
      id: 620000000,
      name: "область Ұлытау",
      oldId: 20,
    },
    {
      id: 630000000,
      name: "Восточно-Казахстанская область",
      oldId: 16,
    },
    {
      id: 710000000,
      name: "г.Астана",
      oldId: 1,
    },
    {
      id: 750000000,
      name: "г.Алматы",
      oldId: 2,
    },
    {
      id: 790000000,
      name: "г.Шымкент",
      oldId: 13,
    },
  ];

  constructor(
    private router: Router,
    private server: ServerService,
    private eventService: EventService
  ) {}

  ngOnInit() {
    let user = localStorage.getItem("user");
    if (user) {
      this.user = JSON.parse(user);
      if (
        this.user.roles.some((e) => e === "MioUser") &&
        this.user.roles.some((e) => e !== "BDAdmin")
      ) {
        this.portalId = 1;
      }
    }
    this.server.getRegions().then(
      (regions) => {
        this.regions = regions;
        this.regions.forEach((r) => {
          this.total = this.total + r.livingComplexCount;
        });
        this.loading = true;
      },
      () => {
        return this.router.navigate(["/login"]);
      }
    );
  }

  selectedRegion: number = 0;
  setRegion(id: number) {
    const matchedId = this.matchingRegions.find(f => f.oldId === id)?.id;
    this.selectedRegion = matchedId;
    localStorage.removeItem("lastRegionId");
    localStorage.removeItem("lastCityId");
    this.eventService.chooseRegionEvent.emit(this.selectedRegion);
    this.eventService.openRegionMap.emit(false);
    this.eventService.disableBodyScrollbar.emit(true);
    localStorage.setItem("lastRegionId", this.selectedRegion.toString());
    localStorage.answer = JSON.stringify(this.selectedRegion);
  }

  getColorOfSelectRegion(id: number) {
    const matchedId = this.matchingRegions.find(f => f.oldId === id)?.id;

    if (this.selectedRegion == 0) {
      this.selectedRegion = localStorage.answer;
    }
    if (this.selectedRegion == matchedId) {
      return "selectReg";
    } else {
      return "";
    }
  }

  getObjectsCount(id: number) {
    const matchedId = this.matchingRegions.find(f => f.oldId === id)?.id;

    if (this.regions && this.regions.length > 0 && matchedId > 0) {
      let regions = this.regions.filter((r) => r.id == matchedId);
      if (regions) {
        return (
          regions[0].livingComplexCount +
          " " +
          this.declOfNum(regions[0].livingComplexCount, [
            "объект",
            "объекта",
            "объектов",
          ])
        );
      }
    }
  }

  declOfNum(number, titles) {
    let cases = [2, 0, 1, 1, 1, 2];
    return titles[
      number % 100 > 4 && number % 100 < 20
        ? 2
        : cases[number % 10 < 5 ? number % 10 : 5]
    ];
  }
}
